import { Box } from '@mantine/core';
import { useMemo } from 'react';

const BAR_COUNT = 24;
const BAR_WIDTH = 3;
const BAR_GAP = 2;
const MAX_HEIGHT = 24;
const MIN_HEIGHT = 3;

interface VoiceWaveformProps {
  audioLevel: number; // 0-1
  color?: string;
}

export function VoiceWaveform({ audioLevel, color = '#EF4444' }: VoiceWaveformProps) {
  // Generate random offsets once (for natural-looking variation)
  const offsets = useMemo(
    () => Array.from({ length: BAR_COUNT }, () => Math.random()),
    [],
  );

  return (
    <Box
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: BAR_GAP,
        height: MAX_HEIGHT,
      }}
    >
      {offsets.map((offset, i) => {
        // Center bars are taller, edges shorter
        const centerWeight = 1 - Math.abs(i - BAR_COUNT / 2) / (BAR_COUNT / 2) * 0.4;
        const h = MIN_HEIGHT + (MAX_HEIGHT - MIN_HEIGHT) * audioLevel * centerWeight * (0.5 + offset * 0.5);
        return (
          <Box
            key={i}
            style={{
              width: BAR_WIDTH,
              height: Math.max(MIN_HEIGHT, h),
              borderRadius: BAR_WIDTH / 2,
              background: color,
              opacity: 0.6 + audioLevel * 0.4,
              transition: 'height 0.08s ease-out',
            }}
          />
        );
      })}
    </Box>
  );
}
